import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MenuOutlined } from "@ant-design/icons";
import { useGuardian, useRouter, useTranslate } from "@bluelibs/x-ui";
import { useMemo } from "react";
import * as Ant from "antd";
import { UserRole } from "@root/api.types";
import { Transactions } from "@bundles/UIAppBundle/icons/transactions";
import { DollarSign } from "@bundles/UIAppBundle/icons/dollarSign";
import { BriefCase } from "@bundles/UIAppBundle/icons/briefcase";
import { Externals } from "@bundles/UIAppBundle/icons/externals";
import { Profile } from "@bundles/UIAppBundle/icons/profile";
import { Logout } from "@bundles/UIAppBundle/icons/logout";
import { Report } from "@bundles/UIAppBundle/icons/report";
import { Users } from "@bundles/UIAppBundle/icons/users";
import { Menu } from "@bundles/UIAppBundle/icons/menu";
import { Bill } from "@bundles/UIAppBundle/icons/bill";
import { Routes } from "@bundles/UIAppBundle";
export const AdminMenu = () => {
    var _a, _b, _c, _d, _e, _f, _g;
    const guardian = useGuardian();
    const router = useRouter();
    const t = useTranslate();
    const ADMIN_ROUTES = [
        {
            name: t("adminMenu.dashboard"),
            route: "/dashboard",
            icon: _jsx(Menu, {}, void 0),
        },
        {
            name: t("adminMenu.banks"),
            route: "/admin/banks",
            icon: _jsx(DollarSign, {}, void 0),
        },
        {
            name: t("adminMenu.bankAccounts"),
            route: "/admin/bank-accounts",
            icon: _jsx(Bill, {}, void 0),
        },
        {
            name: t("adminMenu.companies"),
            route: "/admin/companies",
            icon: _jsx(BriefCase, {}, void 0),
        },
        {
            name: t("adminMenu.externals"),
            route: "/admin/externals",
            icon: _jsx(Externals, {}, void 0),
        },
        {
            name: t("adminMenu.transactions"),
            route: "/admin/transactions",
            icon: _jsx(Transactions, {}, void 0),
        },
        {
            name: t("adminMenu.payments_to_approve"),
            route: "/admin/transactions/payments-to-approve",
            icon: _jsx(Transactions, {}, void 0),
        },
        {
            name: t("adminMenu.ready_for_payment"),
            route: "/admin/transactions/ready-for-payment",
            icon: _jsx(Transactions, {}, void 0),
        },
        {
            name: t("adminMenu.users"),
            route: "/admin/users",
            icon: _jsx(Users, {}, void 0),
        },
        {
            name: t("adminMenu.reports"),
            route: "/admin/reports",
            icon: _jsx(Report, {}, void 0),
        },
        {
            name: t("adminMenu.profile"),
            route: "/admin/profile",
            icon: _jsx(Profile, {}, void 0),
        },
    ];
    const SHARE_HOLDER_ROUTES = [
        {
            name: t("adminMenu.dashboard"),
            route: "/dashboard",
            icon: _jsx(Menu, {}, void 0),
        },
        {
            name: t("adminMenu.banks"),
            route: "/admin/banks",
            icon: _jsx(DollarSign, {}, void 0),
        },
        {
            name: t("adminMenu.bankAccounts"),
            route: "/admin/bank-accounts",
            icon: _jsx(Bill, {}, void 0),
        },
        {
            name: t("adminMenu.companies"),
            route: "/admin/companies",
            icon: _jsx(BriefCase, {}, void 0),
        },
        {
            name: t("adminMenu.externals"),
            route: "/admin/externals",
            icon: _jsx(Externals, {}, void 0),
        },
        {
            name: t("adminMenu.transactions"),
            route: "/admin/transactions",
            icon: _jsx(Transactions, {}, void 0),
        },
        {
            name: t("adminMenu.payments_to_approve"),
            route: "/admin/transactions/payments-to-approve",
            icon: _jsx(Transactions, {}, void 0),
        },
        {
            name: t("adminMenu.ready_for_payment"),
            route: "/admin/transactions/ready-for-payment",
            icon: _jsx(Transactions, {}, void 0),
        },
        {
            name: t("adminMenu.profile"),
            route: "/admin/profile",
            icon: _jsx(Profile, {}, void 0),
        },
    ];
    const ACCOUNTANT_ROUTES = [
        {
            name: t("adminMenu.dashboard"),
            route: "/dashboard",
            icon: _jsx(Menu, {}, void 0),
        },
        {
            name: t("adminMenu.banks"),
            route: "/admin/banks",
            icon: _jsx(DollarSign, {}, void 0),
        },
        {
            name: t("adminMenu.bankAccounts"),
            route: "/admin/bank-accounts",
            icon: _jsx(Bill, {}, void 0),
        },
        {
            name: t("adminMenu.companies"),
            route: "/admin/companies",
            icon: _jsx(BriefCase, {}, void 0),
        },
        {
            name: t("adminMenu.externals"),
            route: "/admin/externals",
            icon: _jsx(Externals, {}, void 0),
        },
        {
            name: t("adminMenu.transactions"),
            route: "/admin/transactions",
            icon: _jsx(Transactions, {}, void 0),
        },
        {
            name: t("adminMenu.payments_to_approve"),
            route: "/admin/transactions/payments-to-approve",
            icon: _jsx(Transactions, {}, void 0),
        },
        {
            name: t("adminMenu.profile"),
            route: "/admin/profile",
            icon: _jsx(Profile, {}, void 0),
        },
    ];
    const menuStatus = useMemo(() => {
        const menuStatus = localStorage.getItem("menu-status");
        if (menuStatus) {
            return menuStatus;
        }
        else {
            return "close";
        }
    }, []);
    const toggleMenu = () => {
        const menu = document.getElementById("x-ui-admin-menu");
        if (menu.classList.contains("x-ui-admin-menu-close")) {
            menu.classList.remove("x-ui-admin-menu-close");
            menu.classList.add("x-ui-admin-menu-open");
            localStorage.setItem("menu-status", "open");
        }
        else if (menu.classList.contains("x-ui-admin-menu-open")) {
            menu.classList.remove("x-ui-admin-menu-open");
            menu.classList.add("x-ui-admin-menu-close");
            localStorage.setItem("menu-status", "close");
        }
    };
    const handleRoute = (route) => {
        router.go({ path: route });
        if (window.innerWidth < 700) {
            toggleMenu();
        }
    };
    return (_jsxs("div", Object.assign({ id: "x-ui-admin-menu", className: `x-ui-admin-menu x-ui-admin-menu-${menuStatus}` }, { children: [_jsxs("div", Object.assign({ className: "logo-container" }, { children: [_jsx("button", Object.assign({ className: "x-ui-admin-menu-toggle", onClick: toggleMenu }, { children: _jsx(MenuOutlined, { style: { fontSize: 18 } }, void 0) }), void 0), _jsx("img", { className: "logo", src: "/public/wp-energy-with-text.png", alt: "wpenergy-logo" }, void 0)] }), void 0), _jsx("div", Object.assign({ className: "language-container" }, { children: _jsx(Ant.Select, { options: [
                        {
                            label: "RO",
                            value: "ro",
                        },
                        {
                            label: "EN",
                            value: "en",
                        },
                    ], className: "language-container-selector", defaultValue: (_a = localStorage.getItem("ln")) !== null && _a !== void 0 ? _a : "ro", onChange: (o) => {
                        localStorage.setItem("ln", o);
                        location.reload();
                    } }, void 0) }), void 0), _jsx("div", Object.assign({ className: "link-container" }, { children: ((_d = (_c = (_b = guardian === null || guardian === void 0 ? void 0 : guardian.state) === null || _b === void 0 ? void 0 : _b.user) === null || _c === void 0 ? void 0 : _c.roles) !== null && _d !== void 0 ? _d : []).includes(UserRole.ADMIN)
                    ? ADMIN_ROUTES.map((route, index) => {
                        return (_jsxs("div", Object.assign({ onClick: () => handleRoute(route.route) }, { children: [route.icon, _jsx("p", { children: route.name }, void 0)] }), index));
                    })
                    : ((_g = (_f = (_e = guardian === null || guardian === void 0 ? void 0 : guardian.state) === null || _e === void 0 ? void 0 : _e.user) === null || _f === void 0 ? void 0 : _f.roles) !== null && _g !== void 0 ? _g : []).includes(UserRole.SHAREHOLDER)
                        ? SHARE_HOLDER_ROUTES.map((route, index) => {
                            return (_jsxs("div", Object.assign({ onClick: () => handleRoute(route.route) }, { children: [route.icon, _jsx("p", { children: route.name }, void 0)] }), index));
                        })
                        : ACCOUNTANT_ROUTES.map((route, index) => {
                            return (_jsxs("div", Object.assign({ onClick: () => handleRoute(route.route) }, { children: [route.icon, _jsx("p", { children: route.name }, void 0)] }), index));
                        }) }), void 0), _jsx("div", Object.assign({ className: "logout-container" }, { children: _jsxs("button", Object.assign({ className: "logout-btn", onClick: () => guardian.logout().then(() => {
                        router.go(Routes.LOGIN);
                        location.reload();
                    }) }, { children: [_jsx(Logout, {}, void 0), _jsx("p", { children: t("adminMenu.logout") }, void 0)] }), void 0) }), void 0)] }), void 0));
};
